export default "__VITE_ASSET__D_3p7cxu__"